module.exports = __webpack_public_path__ + "fonts/ic_library_music_48px.svg";